// import chart1 from '../assets/images/jpg/chart-1.jpg';
import profileImg from '../assets/images/jpg/profile-img.jpg'


const Jpg = {
      // chart1,
      profileImg,
}

export default Jpg;